export default __webpack_public_path__ + "static/a11y-e2ec07deb1c60437075fbf99b3a09586.png";